import { PlayResponse } from '../../types';
import { getTopSlotWinTypes } from './helper';

export function getLocalFortuneWheelsPlayData(): PlayResponse {
    return {
        round: 'uid',
        step: 'uid',
        balance: 100000,
        resp: {
            win: true,
            top_slot: {
                types: getTopSlotWinTypes(),
                type: 'FORTUNE_WHEEL',
                multipliers: ['1', '2', '3', '4', '5', '7', '10', '15', '20', '25', '50'],
                multiplier: '7'
            },
            color: 'YELLOW', // цвет вытянутого шара, null - если не вытянула
            bonus_game: 'FORTUNE_WHEEL', //бонуска
            fortune_wheel_params: {
                sectors: ['10', '15', '20', '25', '50', '100', '250', 'DOUBLE', 'TRIPLE']
            },
            fortune_wheel_result: {
                sector: '10'
            },
            win_type: 'SUPER', //DEFAULT, BIG, SUPER, EPIC, MEGA, NONE
            win_amount: 12345,
            ball_type: ''
        },
        final: true
    };
}
